import React, { useState, useRef } from "react";
import {
    Button,
    Checkbox,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    Glyphicon,
    Row,
    Table,
} from "react-bootstrap";
import { quizQuestionAnswerCreate, quizQuestionAnswerUpdate } from "../../../../../../api/cp";
import DeleteConfirmOverlay from "../../../../UI/DeleteConfirmOverlay";

const AnswerEditor = ({ answer, poll, hasCorrectAnswer, onDelete }) => {
    const [id, setId] = useState(answer?.id);
    const [textRu, setTextRu] = useState(answer?.textRu || '');
    const [textEn, setTextEn] = useState(answer?.textEn || '');
    const [correct, setCorrect] = useState(answer?.correct || false);
    const [isSaving, setSaving] = useState(false);

    const saveProperty = async (name, value) => {
        setSaving(true);
        try {
            let answer;
            if (id) {
                answer = await quizQuestionAnswerUpdate(id, { [name]: value });
            } else {
                answer = await quizQuestionAnswerCreate(poll.id, { [name]: value });
            }
            setId(answer.id);
            setTextRu(answer.textRu);
            setTextEn(answer.textEn);
            setCorrect(answer.correct);
        } catch (e) {
            console.error(e);
        }
        setSaving(false);
    }

    return (
        <tr>
            <td>
                <FormControl
                    type="text"
                    value={textRu}
                    onChange={(e) => setTextRu(e.target.value)}
                    onBlur={() => saveProperty('textRu', textRu)}
                    disabled={isSaving}
                />
            </td>
            <td>
                <FormControl
                    type="text"
                    value={textEn}
                    onChange={(e) => setTextEn(e.target.value)}
                    onBlur={() => saveProperty('textEn', textEn)}
                    disabled={isSaving}
                />
            </td>
            <td>
                {hasCorrectAnswer && (
                    <Checkbox
                        name={`correct-answer-${poll.id}`}
                        checked={correct}
                        onChange={(e) => saveProperty('correct', e.target.checked)}
                        disabled={isSaving}
                    />
                )}
            </td>
            <td>
                <DeleteConfirmOverlay title="Удалить ответ вопроса?" onConfirm={onDelete}>
                    <Button bsStyle="danger" disabled={isSaving}><Glyphicon glyph="trash" /></Button>
                </DeleteConfirmOverlay>
            </td>
        </tr>
    );
}

export default ({ poll, setProperty, savePoll, saveProperty, savePropertyFile, createAnswer, deleteAnswer }) => {

    const imageInputRef = useRef(null);

    if (!poll) return null;

    const hasSkipAnswer = !!poll.answer?.some(({type}) => type === 'skip');

    return <>
        <FormGroup>
            <Row>
                <Col xs={6}>
                    <ControlLabel>Вопрос [Ru]</ControlLabel>
                    <FormControl
                        componentClass="textarea"
                        value={poll.textRu}
                        onChange={(e) => setProperty('textRu', e.target.value)}
                        onBlur={() => saveProperty('textRu', poll.textRu)}
                        rows={3}
                    />
                </Col>
                <Col xs={6}>
                    <ControlLabel>Вопрос [En]</ControlLabel>
                    <FormControl
                        componentClass="textarea"
                        value={poll.textEn}
                        onChange={(e) => setProperty('textEn', e.target.value)}
                        onBlur={() => saveProperty('textEn', poll.textEn)}
                        rows={3}
                    />
                </Col>
            </Row>
        </FormGroup>
        <Row>
            <Col xs={6}>
                <FormGroup>
                    <ControlLabel>Изображение вопроса</ControlLabel>
                    {poll.imageUrl && <div><img src={poll.imageUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}
                    <div>
                        <Button onClick={() => imageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
                        {' '}
                        {poll.imageUrl && <Button onClick={() => saveProperty('image', 'DELETE')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
                    </div>
                    <FormControl
                        type="file"
                        onChange={(e) => savePropertyFile('image', e.target.files[0] || null)}
                        inputRef={ref => imageInputRef.current = ref}
                        style={{ display: 'none' }}
                    />
                </FormGroup>
            </Col>
            <Col xs={2}>
                <ControlLabel>Кол-во ответов</ControlLabel>
                <FormControl
                    componentClass="select"
                    value={poll.multiple ? 'yes' : 'no'}
                    onChange={(e) => savePoll({ multiple: e.target.value === 'yes' })}
                >
                    <option value={'no'}>Один</option>
                    <option value={'yes'}>Несколько</option>
                </FormControl>
            </Col>
            {poll.multiple && <Col xs={2}>
                <ControlLabel>Минимум ответов</ControlLabel>
                <FormControl
                    type="number"
                    min={1}
                    max={poll.answer?.length || 1}
                    value={poll.answerCountMin || 1}
                    onChange={(e) => {
                        const count = parseInt(e.target.value);
                        setProperty('answerCountMin', count);
                        if (count > poll.answerCountMax) {
                            setProperty('answerCountMax', count);
                        }
                    }}
                    onBlur={() => savePoll({ answerCountMin: poll.answerCountMin, answerCountMax: poll.answerCountMax })}
                />
            </Col>}
            {poll.multiple && <Col xs={2}>
                <ControlLabel>Максимум ответов</ControlLabel>
                <FormControl
                    type="number"
                    min={1}
                    max={poll.answer?.length || 1}
                    value={poll.answerCountMax || 1}
                    onChange={(e) => {
                        const count = parseInt(e.target.value);
                        setProperty('answerCountMax', count);
                        if (count < poll.answerCountMin) {
                            setProperty('answerCountMin', count);
                        }
                    }}
                    onBlur={() => savePoll({ answerCountMin: poll.answerCountMin, answerCountMax: poll.answerCountMax })}
                />
            </Col>}
        </Row>
        <Table>
            <thead>
                <tr>
                    <th>Ответ [Ru]</th>
                    <th>Ответ [En]</th>
                    <th width={60}>Правильный</th>
                    <th width={40} />
                </tr>
            </thead>
            <tbody>
                {poll.answer?.map((answer) => (
                    <AnswerEditor
                        key={answer.id}
                        answer={answer}
                        poll={poll}
                        hasCorrectAnswer={answer.type !== 'skip'}
                        onDelete={() => deleteAnswer(answer)}
                    />
                ))}
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan={4}>
                        <Button onClick={() => createAnswer({})}>Добавить вариант ответа</Button>
                        {!hasSkipAnswer && (
                            <Button
                                style={{ marginLeft: '12px' }}
                                onClick={() => createAnswer({ textRu: 'Пропустить', textEn: 'Skip', type: 'skip' })}
                            >
                                Добавить пропуск вопроса
                            </Button>
                        )}
                    </td>
                </tr>
            </tfoot>
        </Table>
    </>
}